/**
 * https connection is required in order to use navigator.clipboard methods on iOS devices.
 */

export const getPastePromise = () => {
  return navigator.clipboard?.readText() || Promise.reject(new Error('Clipboard API not supported'));
};

export const getCopyPromise = (value) => {
  return navigator.clipboard?.writeText(value) || Promise.reject(new Error('Clipboard API not supported'));
};
